import styled from 'styled-components'

export const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: 202px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  background: ${({ theme }) => theme.bsBg2};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`
